import * as React from "react";
import type { SVGProps } from "react";
const SvgHilltopIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M6.72 1.68a.56.56 0 0 0-.56.56v1.737a2.8 2.8 0 0 0-.981.41l-1.23-1.23a.56.56 0 1 0-.792.791l1.23 1.23a2.8 2.8 0 0 0-.41.982H2.24a.56.56 0 0 0 0 1.12h1.737c.073.357.215.687.41.981l-1.23 1.23a.56.56 0 1 0 .791.792l1.231-1.23c.294.194.624.337.981.41V11.2a.56.56 0 0 0 1.12 0V9.463c.357-.073.688-.215.981-.41l1.23 1.23a.56.56 0 0 0 .793 0 .56.56 0 0 0 0-.791L9.053 8.26c.195-.294.337-.624.41-.981H11.2a.56.56 0 0 0 0-1.12H9.463a2.8 2.8 0 0 0-.41-.981l1.23-1.23a.56.56 0 1 0-.791-.793l-1.23 1.231a2.8 2.8 0 0 0-.982-.41V2.24a.56.56 0 0 0-.56-.56m0 3.36c.463 0 .884.188 1.188.492a1.675 1.675 0 0 1 0 2.376 1.675 1.675 0 0 1-2.376 0 1.675 1.675 0 0 1 0-2.376A1.68 1.68 0 0 1 6.72 5.04"
    />
    <path
      fill="#858585"
      fillRule="evenodd"
      d="M9.65 17.755c-1.257 2.79-2.811 6.24-6.301 8.733a.6.6 0 1 1-.698-.976c3.221-2.301 4.656-5.483 5.927-8.302l.15-.332c.643-1.423 1.282-2.787 2.142-3.785.892-1.036 2.032-1.693 3.63-1.693 3.151 0 5.347 2.396 6.821 5.263 1.488 2.894 2.35 6.465 2.772 9.247a.6.6 0 1 1-1.186.18c-.412-2.718-1.249-6.147-2.653-8.878-1.418-2.758-3.305-4.612-5.754-4.612-1.202 0-2.024.467-2.72 1.276-.728.845-1.302 2.044-1.958 3.496z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgHilltopIcon;
